<template>
  <div class="container-fluid">
    <vx-card>
      <h1 v-if="!editMode" class="mb-8">Nueva audiencia"</h1>
      <h1 v-if="editMode" class="mb-8">Editar audiencia</h1>
      <div>
        <vs-input
          class="w-full"
          label="Nombre de la audiencia *"
          name="audience_name"
          v-model.lazy="audience.description"
          icon-pack="feather"
        ></vs-input>
      </div>
      <div>
        <vs-input
          class="w-full mt-3"
          label="Tag *"
          name="audience_tag"
          v-model.lazy="audience.tag"
          icon-pack="feather"
        ></vs-input>
      </div>
      <div>
        <div class="row">
          <div class="col-md-8">
            <vs-textarea
              class="w-full mt-5"
              style="border:none!important"
              placeholder="SELECT ..."
              label="SQL Query *"
              name="audience_query"
              v-model.lazy="audience.db_query"
              :danger-text="db_query_test_message"
              icon-pack="feather"
            ></vs-textarea>
          </div>
          <div class="col-md-4">
            <div class="mt-6 alert alert-info">
              <p>
                El Query debe devolver como minimo la siguiente información:
                <code>{ 'user_id': '', 'email': '', 'name': '', 'email_response':'' }</code>
              </p>
            </div>
          </div>
        </div>

        <div
          class="alert alert-success mb-2"
          v-if="db_query_test_successful">
          El query se ejecuto correctamente, con {{targetCounter}} targets
        </div>
        <div
          class="alert alert-danger"
          v-if="!db_query_test_successful && db_query_test_message !== ''">
          {{db_query_test_message}}
        </div>
      </div>
      <div class="mt-8 flex">
        <vs-button
          :disabled="db_query_test_successful"
          color="success"
          @click="testDbQuery()"
          icon="bolt"
          size="medium">
          Test SQL
        </vs-button>

        <vs-button
          v-if="!editMode"
          class="ml-4"
          :disabled="!db_query_test_successful"
          @click="saveAudience()">
          Guardar audiencia
        </vs-button>

        <vs-button
          v-else
          class="ml-4"
          :disabled="!db_query_test_successful"
          @click="editAudience()">
          Actualizar audiencia
        </vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "Form",
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    // titleForm: "Nueva audiencia",
    db_query_test_message: "",
    db_query_last_correctly_executed: "",
    db_query_test_successful: false,
    targetCounter: 0,
    audience: {
      id: null,
      description: null,
      db_query: "SELECT DISTINCT id as user_id, email, '' as name, email_response FROM users",
      tag: null
    }
  }),
  async mounted() {
    if (this.editMode) {
      this.audience.id = this.$route.params.id;
    }
  },
  watch: {
    'audience.db_query': function (value) {
      this.db_query_test_successful = this.db_query_last_correctly_executed === value;
    },
  },
  methods: {
    async testDbQuery() {
      try {
        const {data} = await axios.post(`/api/app-http-services/services/notifications/email/audiences/test-query`, {
          db_query: this.audience.db_query
        })
        this.targetCounter = data.targets;
        this.db_query_test_successful = true;
        this.db_query_last_correctly_executed = this.audience.db_query.toString();
      } catch (e) {
        if(e.response.status === 400) {
          this.db_query_test_successful = false;
          this.db_query_test_message = e.response.data.error;
        }
        if(e.response.status === 500) {
          this.db_query_test_successful = false;
          this.db_query_test_message = e.response.data.message;
        }
      }
    },
    async saveAudience() {
      try {
        await axios.post(`/api/app-http-services/services/notifications/email/audiences`, this.audience)
        this.$router.back();
      } catch (e) {
        if(e.response.status === 422) {
          await swal("Notificación", JSON.stringify(e.response.data.errors), "warning")
        }
        if(e.response.status === 500) {
          await swal("Error", "Hubo un error al guardar la audience", "error")
        }
      }
    },
    async editAudience() {
      try {
        await axios.put(`/api/app-http-services/services/notifications/email/audiences/${this.audience.id}`, this.audience)
        this.$router.back();
      } catch (e) {
        if(e.response.status === 422) {
          await swal("Notificación", JSON.stringify(e.response.data.errors), "warning")
        }
        if(e.response.status === 500) {
          await swal("Error", "Hubo un error al actualizar la audiencia", "error")
        }
      }
    },
  }
}
</script>
